<div class="cp-page">
  <div class="cp-header">
    <div>
      <div class="ct" style="font-size:20px">{{ 'commPrevention.list.title' | translate }}</div>
      <div class="cs">{{ 'commPrevention.list.subtitle' | translate }}</div>
    </div>
    <div class="cp-actions">
      <button class="cp-create-btn" (click)="goCreate()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
        {{ 'commPrevention.list.createButton' | translate }}
      </button>
    </div>
  </div>

  @if (subjectFilter()) {
    <div class="cp-filter-banner">
      {{ 'commPrevention.list.filteredBySubject' | translate: { subject: subjectFilter() } }}
      <button type="button" class="cp-filter-clear" (click)="clearSubjectFilter()">{{ 'commPrevention.list.clearFilter' | translate }}</button>
    </div>
  }

  @if (loadError()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'commPrevention.list.error' | translate }}</div></div>
  } @else if (loading()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'commPrevention.list.loading' | translate }}</div></div>
  } @else if (filteredCampaigns().length === 0) {
    <div class="card cp-empty">
      <div class="cs" style="margin-bottom:4px">{{ (subjectFilter() ? 'commPrevention.list.emptyFilteredTitle' : 'commPrevention.list.emptyTitle') | translate }}</div>
      <div class="cs" style="margin-bottom:16px">{{ 'commPrevention.list.emptySubtitle' | translate }}</div>
      <button class="cp-create-btn" (click)="goCreate()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
        {{ 'commPrevention.list.createButton' | translate }}
      </button>
    </div>
  } @else {
    <div class="card cp-table-card">
      <div class="cp-table-wrap">
        <table class="cp-table">
          <thead>
            <tr>
              <th>{{ 'commPrevention.list.table.subject' | translate }}</th>
              <th>{{ 'commPrevention.list.table.type' | translate }}</th>
              <th>{{ 'commPrevention.list.table.diffusion' | translate }}</th>
              <th>{{ 'commPrevention.list.table.dates' | translate }}</th>
              <th>{{ 'commPrevention.list.table.offer' | translate }}</th>
              <th>{{ 'commPrevention.list.table.status' | translate }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (row of filteredCampaigns(); track row.campaignId) {
              <tr class="cp-row" tabindex="0" role="link" (click)="goView(row)" (keydown.enter)="goView(row)">
                <td class="cp-subject-cell">{{ row.subject }}<div class="cp-titre-sub">{{ row.titre }}</div></td>
                <td>{{ ('commPrevention.list.type.' + row.type) | translate }}</td>
                <td>{{ row.siteCount === 1 ? ('commPrevention.list.oneSite' | translate) : ('commPrevention.list.sitesCount' | translate: { count: row.siteCount }) }}</td>
                <td>{{ formatDates(row) }}</td>
                <td>{{ row.offerName || ('commPrevention.list.noOffer' | translate) }}</td>
                <td>
                  <span class="badge cp-status-badge" [class]="'status-' + row.status">{{ ('commPrevention.list.status.' + row.status) | translate }}</span>
                  @if (row.deliverabilityStatus === 'PARTIALLY_BLOCKED') {
                    <div class="cp-deliverability-warning">⚠ {{ 'commPrevention.list.deliverability.partiallyBlocked' | translate: { count: row.blockedSiteCount ?? 0 } }}</div>
                  } @else if (row.deliverabilityStatus === 'BLOCKED') {
                    <div class="cp-deliverability-warning">⚠ {{ 'commPrevention.list.deliverability.blocked' | translate }}</div>
                  }
                </td>
                <td class="cp-actions-cell">
                  <button class="btn-ps-sm" (click)="goView(row); $event.stopPropagation()">{{ 'commPrevention.list.action.view' | translate }}</button>
                  @if (row.status !== 'ENDED') {
                    <button type="button" class="cp-suspend-btn" [attr.aria-label]="'commPrevention.list.action.suspend' | translate" [attr.title]="'commPrevention.list.action.suspend' | translate" (click)="openSuspendConfirm(row, $event)">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

  @if (suspendTarget(); as target) {
    <app-confirm-modal
      [title]="'commPrevention.confirm.suspendTitle' | translate"
      [message]="'commPrevention.confirm.suspendMessage' | translate: { subject: target.subject }"
      [confirmText]="'commPrevention.confirm.suspendButton' | translate"
      [cancelText]="'commPrevention.confirm.cancelButton' | translate"
      [loading]="suspending()"
      (confirm)="confirmSuspend()"
      (cancel)="closeSuspendConfirm()">
    </app-confirm-modal>
  }
</div>
